import type {
  HistoricoAcompanhamentoOutputType,
  HistoricoCompletoOutputType,
  HistoricoCompletoQueryType,
  HistoricoQueryType,
  MarcarRelatorioEnviadoOutputType,
  PendenciasOutputType,
  RegistroDetalheOutputType,
  RegistroInputType,
  RegistroResumoOutputType,
  RegistroUpdateInputType,
} from '../../../shared/dto';
import { callApi } from './call-api';

type HistoricoCompletoFiltros = Omit<HistoricoCompletoQueryType, 'dataInicio' | 'dataFim'> & {
  dataInicio?: Date | string;
  dataFim?: Date | string;
};

export const registrosApi = {
  listarDoDia: ({ data }: { data: Date | string }) =>
    callApi<RegistroResumoOutputType[]>({
      path: '/registros',
      query: { data },
    }),

  contarPendencias: (_args: void) =>
    callApi<PendenciasOutputType>({
      path: '/registros/pendencias',
    }),

  buscar: (id: string) =>
    callApi<RegistroDetalheOutputType>({
      path: `/registros/${id}`,
    }),

  criar: (body: RegistroInputType) =>
    callApi<RegistroDetalheOutputType>({
      method: 'POST',
      path: '/registros',
      body,
    }),

  atualizar: ({ id, dados }: { id: string; dados: RegistroUpdateInputType }) =>
    callApi<RegistroDetalheOutputType>({
      method: 'PUT',
      path: `/registros/${id}`,
      body: dados,
    }),

  melhorarRelatorio: (id: string) =>
    callApi<RegistroDetalheOutputType>({
      method: 'POST',
      path: `/registros/${id}/relatorio/melhorar`,
    }),

  marcarRelatorioEnviado: (id: string) =>
    callApi<MarcarRelatorioEnviadoOutputType>({
      method: 'POST',
      path: `/registros/${id}/relatorio/enviado`,
    }),

  obterHistorico: ({ alunoId, filtros }: { alunoId: string; filtros: HistoricoQueryType }) =>
    callApi<HistoricoAcompanhamentoOutputType>({
      path: `/alunos/${alunoId}/registros/historico`,
      query: filtros,
    }),

  obterHistoricoCompleto: ({
    alunoId,
    filtros,
  }: {
    alunoId: string;
    filtros: HistoricoCompletoFiltros;
  }) =>
    callApi<HistoricoCompletoOutputType>({
      path: `/alunos/${alunoId}/registros/historico-completo`,
      query: filtros,
    }),
};
